<script lang="ts">
  import { Button } from '@shared/ui/buttons/button';
  import { Select } from '@shared/ui/fields/select';
  import { Sidebar } from '@shared/ui/sidebar';
  import { theme, ThemeModes } from '@shared/ui/theme';
  import { cn } from '@shared/utils';

  import { artistsFilterSidebarActivity } from '../model';

  // TODO: mocked form, will be replaced with superform
  const form = {
    artist: undefined,
    style: undefined,
    medium: undefined,
    country: undefined,
  };

  const stylesOptions = [
    { text: 'All styles', value: 'all' },
    { text: 'Abstract', value: 'abstract' },
    { text: 'Contemporary', value: 'contemporary' },
    { text: 'Modern', value: 'modern' },
    { text: 'Pop art', value: 'pop_art' },
    { text: 'Street art', value: 'street_art' },
  ];
</script>

<Sidebar sidebarActivity="{$artistsFilterSidebarActivity}" handleClose="{() => artistsFilterSidebarActivity.close()}">
  <div class="{cn('filter-sidebar flex h-full flex-col', { dark: $theme === ThemeModes.Dark })}">
    <div class="flex items-center justify-between px-6 py-[22px]">
      <span class="text-default-900 dark:text-dark-900 font-inter text-xl font-semibold">Filter</span>
      <Button size="sm" variant="secondary" iconName="trash" iconPosition="left" hugged>Clear</Button>
    </div>
    <div class="flex-grow space-y-4 overflow-auto px-5 py-6">
      <div class="space-y-3">
        <div class="dark:text-dark-900 text-base font-medium">Styles</div>
        <div>
          <Select
            options="{stylesOptions}"
            selectedOption="{form.style}"
            isMulti
            on:change="{(e) => {
              console.log(e.detail);
            }}"
          />
        </div>
      </div>
      <div class="space-y-3">
        <div class="dark:text-dark-900 text-base font-medium">Medium</div>
        <div>
          <Select
            options="{[]}"
            selectedOption="{form.medium}"
            on:change="{(e) => {
              console.log(e.detail);
            }}"
          />
        </div>
      </div>
      <div class="space-y-3">
        <div class="dark:text-dark-900 text-base font-medium">Country</div>
        <div>
          <Select
            options="{[]}"
            selectedOption="{form.country}"
            on:change="{(e) => {
              console.log(e.detail);
            }}"
          />
        </div>
      </div>
    </div>
    <div class="px-6 py-[22px]">
      <Button size="md">Show (13) artists</Button>
    </div>
  </div>
</Sidebar>

<style>
  .filter-sidebar :global(.rangeSlider) {
    --range-range-inactive: #e9e9e9;
    --range-range: #737373; /* active range color */
    --range-handle-inactive: #cccccc; /* inactive handle color */
    --range-handle: #171717; /* non-focussed handle color */
    --range-handle-focus: #171717; /* focussed handle color */
  }

  .filter-sidebar :global(.pip.selected .pipVal) {
    font-weight: normal;
  }

  .dark :global(.rangeSlider) {
    --range-range-inactive: #3c3c3c;
    --range-range: #acacac; /* active range color */
    --range-handle-inactive: #666; /* inactive handle color */
    --range-handle: #fff; /* non-focussed handle color */
    --range-handle-focus: #fff; /* focussed handle color */
  }
</style>
